const CUSTOMER_ORGANIZATION_UUID_QUERY_PARAM = 'customer_organization_uuid';

export function getCustomerOrganizationUuidFromSearchParams(
    searchParams: URLSearchParams
): string | undefined {
    const rawValue: string | null = searchParams.get(CUSTOMER_ORGANIZATION_UUID_QUERY_PARAM);
    if (rawValue === null || rawValue.trim().length === 0) {
        return undefined;
    }
    return rawValue;
}

export function appendCustomerOrganizationUuid(
    path: string,
    customerOrganizationUuid: string | undefined
): string {
    if (customerOrganizationUuid === undefined) {
        return path;
    }
    const url = new URL(path, 'https://anchorbase.invalid');
    url.searchParams.set(CUSTOMER_ORGANIZATION_UUID_QUERY_PARAM, customerOrganizationUuid);
    return `${url.pathname}${url.search}`;
}
